export default __webpack_public_path__ + "static/media/login_bg_1200_no_car.105d81d5.png";